import {ApplyGameFilterResult, IGameFilterEvaluator} from "./game-filter-evaluator.interface";
import {GameInfo} from "../../games/game-info";

export class AndGameFiltersEvaluator implements IGameFilterEvaluator {
    constructor(...evaluators: IGameFilterEvaluator[]) {
        this._evaluators = evaluators;
    }

    private readonly _evaluators: IGameFilterEvaluator[];

    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
        let result = ApplyGameFilterResult.NotApplicable;
        for(let evaluator of this._evaluators) {
            const r = evaluator.applyFilter(gameInfo);
            if(r === ApplyGameFilterResult.ExcludeGame) {
                return r;
            } else if(r !== ApplyGameFilterResult.NotApplicable) {
                result = r;
            }
        }

        return result;
    }
}

export function AND(...evaluators: IGameFilterEvaluator[]): IGameFilterEvaluator {
    return new AndGameFiltersEvaluator(...evaluators);
}